import type {RecruitmentDetailResponse} from '../../core/entities/recruitment/schema';

export const createJobPostingStructuredData = (
  recruitmentDetail: RecruitmentDetailResponse,
  companyName: string,
  companyId: number,
  currentUrl: string,
  companyLogoImageUrl: string,
) => {
  // 構造化データ https://developers.google.com/search/docs/appearance/structured-data/job-posting?hl=ja
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'JobPosting',
      title: recruitmentDetail.title,
      description: recruitmentDetail.resources[0]?.content,
      identifier: {
        '@type': 'PropertyValue',
        name: companyName,
        value: companyId,
      },
      datePosted: recruitmentDetail.modifiedAt,
      validThrough: recruitmentDetail.displayEndAt,
      applicantLocationRequirements: {
        '@type': 'Country',
        name: 'Japan',
      },
      jobLocationType: 'TELECOMMUTE',
      employmentType: recruitmentDetail.typeV2.key,
      hiringOrganization: {
        '@type': 'Organization',
        name: companyName,
        sameAs: currentUrl,
        logo: companyLogoImageUrl,
      },
    },
  ];
  return structuredData;
};
